import type { UserRole } from '@/features/server/actions/rbac/types';

const roles: UserRole[] = ['student', 'teacher', 'org_admin', 'internal', 'superuser'] as const;

export const isAtLeastRole = (userRole: UserRole | null, atLeastRole: UserRole | null): boolean => {
  // i think false makes sense?
  if (!userRole || !atLeastRole) return false;
  const userRoleIdx = roles.findIndex((role) => role === userRole);
  const atLeastRoleIdx = roles.findIndex((role) => role === atLeastRole);

  return userRoleIdx >= atLeastRoleIdx;
};
